module.exports = __webpack_public_path__ + "static/media/YF51_5.31bc1089.jpg";